// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Standalone-only styles — loaded only by bootstrap.tsx (not by MFE component chunks).
   These rules must NOT be in styles.css to prevent leaking into the host application. */

html,
body,
#root {
  margin: 0;
  min-height: 100%;
}

body {
  min-height: 100vh;
  background:
    radial-gradient(circle at 15% 10%, rgba(74, 138, 222, 0.2), transparent 38%),
    linear-gradient(180deg, var(--bg-top) 0%, var(--bg-bottom) 100%);
}
`, "",{"version":3,"sources":["webpack://./src/standalone.css"],"names":[],"mappings":"AAAA;wFACwF;;AAExF;;;EAGE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB;;oEAEkE;AACpE","sourcesContent":["/* Standalone-only styles — loaded only by bootstrap.tsx (not by MFE component chunks).\n   These rules must NOT be in styles.css to prevent leaking into the host application. */\n\nhtml,\nbody,\n#root {\n  margin: 0;\n  min-height: 100%;\n}\n\nbody {\n  min-height: 100vh;\n  background:\n    radial-gradient(circle at 15% 10%, rgba(74, 138, 222, 0.2), transparent 38%),\n    linear-gradient(180deg, var(--bg-top) 0%, var(--bg-bottom) 100%);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
